// English translations
export default {
  common: {
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    search: 'Search',
    filter: 'Filter',
    noResults: 'No results found',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    required: 'Required',
    optional: 'Optional',
    yes: 'Yes',
    no: 'No',
    success: 'Success',
    confirm: 'Confirm',
    actions: 'Actions',
    notifications: 'Notifications',
    menu: 'Menu',
    noNotifications: 'No new notifications',
    markAllAsRead: 'Mark all as read',
    dismiss: 'Dismiss',
    viewAll: 'View all',
    serverNotResponding: 'Server not responding. Please check your connection.',
    unexpectedError: 'An unexpected error occurred',
    tryAgain: 'Please try again',
    contactSupport: 'If the problem persists, please contact support',
    store: 'Store',
    warning: 'Warning',
    info: 'Information',
    close: 'Close',
    goodMorning: 'Good Morning',
    goodAfternoon: 'Good Afternoon',
    goodEvening: 'Good Evening',
    user: 'User'
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    email: 'Email address',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    signIn: 'Sign in to your account',
    signingIn: 'Signing in...',
    rememberMe: 'Remember me',
    loginError: 'Failed to sign in',
    passwordResetSent: 'If an account exists with this email, you will receive password reset instructions',
    passwordResetSuccess: 'Your password has been reset successfully',
    emailRequired: 'Email is required',
    invalidEmail: 'Please enter a valid email address',
    passwordRequired: 'Password is required',
    passwordLength: 'Password must be at least 8 characters',
    noAccount: 'Don\'t have an account?',
    registerCta: 'Register',
    passwordResetInstructions: 'Enter your email address and we\'ll send you instructions to reset your password',
    sending: 'Sending...',
    sendResetInstructions: 'Send reset instructions',
    checkEmailForReset: 'Check your email for password reset instructions. The link will expire in 1 hour',
    didntReceiveEmail: 'Didn\'t receive the email? Check your spam folder or try again',
    backToLogin: 'Back to login',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 8 characters long',
    passwordResetSuccessTitle: 'Password Reset Successful',
    passwordResetSuccessMessage: 'Your password has been reset. You will be redirected to login.',
    resetPasswordError: 'Failed to reset password',
    invalidResetLink: 'Invalid reset link. Please request a new password reset.',
    goToForgotPassword: 'Go to forgot password',
    resetting: 'Resetting...',
    createAccount: 'Create a new account',
    fullName: 'Full Name',
    storeNumber: 'Store Number',
    storeNumberPlaceholder: 'e.g., 00727',
    creatingAccount: 'Creating account...',
    alreadyHaveAccount: 'Already have an account? Sign in',
    registrationSuccessful: 'Registration successful. Please login.',
    registrationFailed: 'Registration failed'
  },
  navigation: {
    dashboard: 'Dashboard',
    evaluations: 'Evaluations',
    myEvaluations: 'My Evaluations',
    employees: 'Employees',
    training: 'Training',
    reports: 'Reports',
    settings: 'Settings',
    profile: 'Profile',
    help: 'Help',
    admin: 'Admin',
    leadership: 'Leadership',
    kitchen: 'Kitchen',
    tasks: 'Tasks',
    me: 'ME',
    teamMembers: 'Team Members',
    myProfile: 'My Profile',
    userMenu: 'User Menu',
    wasteTracker: 'Waste Tracker',
    analytics: 'Analytics',
    equipmentStatus: 'Equipment Status',
    foodSafety: 'Food Safety',
    cleaningSchedule: 'Cleaning Schedule'
  },
  users: {
    title: 'Team Members',
    subtitle: 'Manage your team members and their information',
    searchPlaceholder: 'Search by name, email, or position...'
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    welcomeBack: 'Welcome back, {{name}}!',
    viewFullProfile: 'View Full Profile',
    upcomingEvaluations: 'Upcoming Evaluations',
    recentActivity: 'Recent Activity',
    quickStats: 'Quick Stats',
    viewAll: 'View All',
    evaluationsDue: 'Evaluations Due',
    employeesInTraining: 'Employees in Training',
    completedEvaluations: 'Completed Evaluations',
    pendingReviews: 'Pending Reviews',
    currentPerformance: 'Current Performance',
    nextEvaluation: 'Next Evaluation',
    daysAway: '{{days}} days away',
    lastEvaluation: 'Last evaluation: {{date}}',
    completeSelfEvaluation: 'Complete Self-Evaluation',
    pendingManagerReview: 'Pending Manager Review',
    reviewAndAcknowledge: 'Review & Acknowledge',
    notScheduled: 'Not Scheduled',
    noUpcomingEvaluation: 'No upcoming evaluation',
    activeGoals: 'Active Goals',
    goalsInProgress: 'goals in progress',
    currentGoals: 'Current Goals',
    trackYourProgress: 'Track your progress',
    noActiveGoals: 'No active goals',
    due: 'Due {{date}}',
    trainingProgress: 'Training Progress',
    yourAssignedTrainingPlans: 'Your assigned training plans',
    noActiveTrainingPlans: 'No active training plans',
    activeTraining: 'Active Training',
    tasksCompleted: '{{completed}} of {{total}} tasks completed',
    recentlyCompleted: 'Recently Completed',
    completedOn: 'Completed {{date}}',
    recentAchievements: 'Recent Achievements',
    yourLatestAccomplishments: 'Your latest accomplishments',
    noRecentAchievements: 'No recent achievements',
    upcomingSchedule: 'Upcoming Schedule',
    yourNextEvents: 'Your next events',
    noScheduleDataAvailable: 'No schedule data available',
    noUpcomingEvents: 'No upcoming events',
    developmentGoals: 'Development Goals',
    viewEvaluationHistory: 'View evaluation history',
    viewRequiredTraining: 'View required training',
    newIncident: 'New Incident',
    completedInDays: '{{count}} completed in 30 days',
    openIncidents: 'Open Incidents',
    resolvedThisMonth: '{{count}} resolved this month',
    teamSize: 'Team Size',
    inTraining: '{{count}} new hires',
    overallPerformance: 'Overall Performance',
    fromLastMonth: '+2.5% from last month',
    performanceTrends: 'Performance Trends',
    performanceDescription: 'FOH vs BOH evaluation scores by month',
    performanceContext: 'Percentage of total possible evaluation points earned',
    evaluationCount: '{{count}} evaluations',
    fohEvaluations: '{{count}} FOH',
    bohEvaluations: '{{count}} BOH',
    quickActions: 'Quick Actions',
    scheduleEvaluation: 'Schedule Evaluation',
    setTeamGoals: 'Set Team Goals',
    viewTeam: 'View Team',
    trainingMaterials: 'Training Materials',
    next7Days: 'Next 7 days',
    last7Days: 'Last 7 days',
    noUpcomingEvaluations: 'No upcoming evaluations',
    recentIncidents: 'Recent Incidents',
    recentDocumentation: 'Recent Documentation',
    noActiveIncidents: 'No active incidents',
    noRecentDocumentation: 'No Recent Documentation',
    last30Days: 'Last 30 days',
    showingRecords: 'Showing {{shown}} of {{total}} records',
    kitchenEquipment: 'Kitchen Equipment',
    kitchenTasksDetail: 'Kitchen Task Completion',
    kitchenTasksDescription: 'Kitchen checklist completion status',
    equipmentStatus: 'Equipment Status',
    equipmentStatusDescription: 'Kitchen equipment operational status',
    foodSafety: 'Food Safety',
    foodSafetyDescription: 'Temperature checks and critical tasks',
    fohTasks: 'FOH Tasks',
    todaysTasks: 'Today\'s task completion status',
    refresh: 'Refresh'
  },
  evaluations: {
    title: 'Evaluations',
    schedule: 'Schedule',
    create: 'Create Evaluation',
    view: 'View Evaluation',
    edit: 'Edit Evaluation',
    delete: 'Delete Evaluation',
    status: 'Status',
    employee: 'Employee',
    evaluator: 'Evaluator',
    date: 'Date',
    score: 'Score',
    comments: 'Comments',
    submit: 'Submit Evaluation',
    draft: 'Save as Draft',
    pending: 'Pending',
    completed: 'Completed',
    approved: 'Approved',
    rejected: 'Rejected',
    scheduled: 'Scheduled',
    inProgress: 'In Progress',
    overdue: 'Overdue',
    upcoming: 'Upcoming',
    noEvaluations: 'No evaluations found',
    confirmDelete: 'Are you sure you want to delete this evaluation?',
    deleteSuccess: 'Evaluation deleted successfully',
    saveSuccess: 'Evaluation saved successfully',
    submitSuccess: 'Evaluation submitted successfully'
  },
  employees: {
    title: 'Employees',
    add: 'Add Employee',
    edit: 'Edit Employee',
    view: 'View Employee',
    delete: 'Delete Employee',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    position: 'Position',
    department: 'Department',
    hireDate: 'Hire Date',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    evaluations: 'Evaluations',
    training: 'Training',
    noEmployees: 'No employees found',
    confirmDelete: 'Are you sure you want to delete this employee?',
    deleteSuccess: 'Employee deleted successfully',
    saveSuccess: 'Employee saved successfully'
  },
  training: {
    title: 'Training',
    dashboard: 'Training Dashboard',
    plans: 'Training Plans',
    progress: 'Training Progress',
    newHires: 'New Hires',
    completionRate: 'Completion Rate',
    trainingPlans: 'Training Plans',
    employeesNeedTraining: 'Employees Need Training',
    viewEmployees: 'View Employees',
    failedToLoadStats: 'Failed to load dashboard statistics',
    createPlan: 'Create Training Plan',
    editPlan: 'Edit Training Plan',
    deletePlan: 'Delete Training Plan',
    planName: 'Plan Name',
    planDescription: 'Plan Description',
    planType: 'Plan Type',
    modules: 'Modules',
    addModule: 'Add Module',
    moduleTitle: 'Module Title',
    moduleDescription: 'Module Description',
    moduleContent: 'Module Content',
    savePlan: 'Save Plan',
    cancel: 'Cancel',
    confirmDelete: 'Are you sure you want to delete this training plan?',
    planDeleted: 'Training plan deleted successfully',
    planSaved: 'Training plan saved successfully',
    assignTraining: 'Assign Training',
    selectEmployees: 'Select Employees',
    selectTrainingPlan: 'Select Training Plan',
    assign: 'Assign',
    trainingAssigned: 'Training assigned successfully'
  },
  settings: {
    title: 'Settings',
    subtitle: 'Manage your store settings',
    general: 'General Settings',
    appearance: 'Appearance',
    language: 'Language',
    english: 'English',
    spanish: 'Spanish',
    darkMode: 'Dark Mode',
    compactMode: 'Compact Mode',
    // Kitchen section
    kitchenChecklistOptions: 'Checklist Options',
    kitchenChecklistOptionsDescription: 'Choose which shift checklists your kitchen runs each day',
    kitchenShiftTimes: 'Shift Times',
    kitchenShiftTimesDescription: 'Set when each shift starts and ends so checklists open at the right time',
    // Store info section
    storeInfo: 'Store Information',
    storeInformation: 'Store Information',
    storeInformationDescription: 'Manage the store contact details used across the app',
    storeName: 'Store Name',
    storeNumber: 'Store Number',
    storeAddress: 'Store Address',
    storePhone: 'Phone Number',
    storeEmail: 'Email Address',
    visionStatement: 'Vision Statement',
    missionStatement: 'Mission Statement',
    saveChanges: 'Save Changes',
    resetToDefault: 'Reset to Default',
    confirmReset: 'Are you sure you want to reset all settings to default?',
    settingsSaved: 'Settings saved successfully',
    resetSuccess: 'Settings reset to default values',
    gradingScales: 'Grading Scales',

    // User Access Settings
    userAccess: 'User Access',
    roleManagement: 'Role Management',
    storeDirectorAccess: 'Store Director Access',
    kitchenDirectorAccess: 'Kitchen Director Access',
    serviceDirectorAccess: 'Service Director Access',
    storeLeaderAccess: 'Store Leader Access',
    trainingLeaderAccess: 'Training Leader Access',
    shiftLeaderAccess: 'Shift Leader Access',
    fohLeaderAccess: 'FOH Leader Access',
    bohLeaderAccess: 'BOH Leader Access',
    dtLeaderAccess: 'DT Leader Access',
    roleManagementDescription: 'Choose what each leadership role can see and do',
    storeDirectorAccessDescription: 'Full access to every area of the store',
    kitchenDirectorAccessDescription: 'Full access to kitchen operations and BOH team members',
    serviceDirectorAccessDescription: 'Full access to front-of-house operations and FOH team members',
    storeLeaderAccessDescription: 'Manage daily operations across both departments',
    trainingLeaderAccessDescription: 'Manage training plans, certifications, and new hire progress',
    shiftLeaderAccessDescription: 'Run the shift and manage team members on the clock',
    fohLeaderAccessDescription: 'Lead front counter and dining room during a shift',
    bohLeaderAccessDescription: 'Lead kitchen and food prep during a shift',
    dtLeaderAccessDescription: 'Lead drive-thru during a shift',

    // Password and account security
    passwordRequirements: 'Set the rules team members must follow when creating a password',
    minLength: 'Minimum length',
    characters: 'characters',
    requireNumbers: 'Require Numbers',
    requireNumbersDescription: 'Passwords must contain at least one number',
    requireSpecialChars: 'Require Special Characters',
    requireSpecialCharsDescription: 'Passwords must contain at least one symbol, such as ! or #',
    security: 'Account Security',
    securityDescription: 'Control how long people stay signed in and how failed logins are handled',
    sessionTimeout: 'Session Timeout',
    sessionTimeoutDescription: 'Sign a user out automatically after this much inactivity',
    selectTimeout: 'Select a timeout',
    minutes: 'minutes',
    hour: 'hour',
    hours: 'hours',
    maxLoginAttempts: 'Max Login Attempts',
    maxLoginAttemptsDescription: 'Lock the account after this many failed sign-in attempts',
    selectAttempts: 'Select attempts',
    attempts: 'attempts',

    // Evaluation Settings
    evaluation: 'Evaluation Settings',
    evaluationDescription: 'Control how evaluations are reviewed and approved',
    workflowTypeDescription: 'How many approval steps an evaluation goes through before it is final',
    selectWorkflow: 'Select a workflow',
    trainingAccessDescription: 'Who can create and assign training plans',
    certificationApprovalDescription: 'Who can sign off when a team member completes a certification',
    metricsAccessDescription: 'Who can view store performance metrics and reports',
    errorSavingSettings: 'Could not save your settings. Please try again.',
    updateError: 'Something went wrong while updating. Please try again.',
    departmentRestriction: 'Department Restriction',
    requireStoreLeaderReview: 'Require Store Leader Review',
    requireDirectorApproval: 'Require Director Approval',
    trainingAccess: 'Training Access',
    certificationApproval: 'Certification Approval',
    metricsAccess: 'Metrics Access',
    workflowType: 'Workflow Type',
    workflowSimple: 'Simple',
    workflowStandard: 'Standard',
    workflowStrict: 'Strict',

    // Evaluation Scheduling
    scheduling: 'Scheduling',
    autoSchedule: 'Auto Schedule Evaluations',
    frequency: 'Evaluation Frequency (Days)',
    cycleStart: 'Evaluation Cycle Start',
    hireDate: 'Hire Date',
    calendarYear: 'Calendar Year',
    fiscalYear: 'Fiscal Year',
    custom: 'Custom Date',
    customStartDate: 'Custom Start Date',
    transitionMode: 'Transition Mode',
    immediate: 'Immediate',
    completeCycle: 'Complete Cycle',
    alignNext: 'Align Next',

    // Access Control Settings
    setupViewAccess: 'Setup View Access',
    setupViewAccessDescription: 'Control who can access the Setup View feature',
    evaluationAccessControls: 'Evaluation Access Controls',
    evaluationAccessControlsDescription: 'Manage evaluation permissions for different roles',

    // Settings descriptions
    darkModeDescription: 'Enable dark mode for the application',
    compactModeDescription: 'Use compact layout to show more content',
    languageDescription: 'Select your preferred language',
    departmentRestrictionDescription: 'Restrict evaluators to only evaluate team members in their department',
    storeLeaderReviewDescription: 'Require store leader review before finalizing evaluations',
    directorApprovalDescription: 'Require director approval for completed evaluations',
    autoScheduleDescription: 'Automatically schedule evaluations based on frequency',

    // Validation and errors
    validationError: 'Please fix the validation errors before saving',
    storeNumberRequired: 'Store number is required',
    storeNameRequired: 'Store name is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',

    // Why We Exist Form
    whyWeExist: 'Why We Exist',
    purpose: 'Purpose',
    purposePlaceholder: "Enter your store's core purpose...",
    purposeExample: 'Example: "To change family trees"',
    mission: 'Mission',
    missionPlaceholder: "Enter your store's mission statement...",
    missionExample: 'Example: "To foster a hospitality environment that emphasizes flawless execution and promotes a culture of continuous learning"',
    values: 'Values',
    valuesPlaceholder: 'Enter a core value...',
    valuesExamples: 'Examples: "Fully committed to our people", "Obsess over our guests", "Flawless execution", "Create a hospitable atmosphere"',
    strategy: 'Strategy',
    strategyPlaceholder: "Enter your store's strategic approach...",
    strategyExample: 'Example: "To capture market share through pairing flawless execution with a steadfast commitment to engaging our guests within their lives"',
    saving: 'Saving...',
    saveWhyStatement: 'Save Why Statement',
  },
  errors: {
    notFound: 'Page not found',
    unauthorized: 'You are not authorized to access this page',
    serverError: 'Server error occurred',
    networkError: 'Network error occurred',
    tryAgain: 'Please try again',
    contactSupport: 'If the problem persists, please contact support'
  },
  notifications: {
    failedToLoad: 'Failed to load notifications',
    failedToProcess: 'Failed to process notification',
    failedToDelete: 'Failed to delete notification. Please try again.',
    markAllAsRead: 'Mark all as read',
    viewAll: 'View all notifications',
    invalidNotification: 'Invalid notification: No notification ID found',
    dismissSuccess: 'Notification dismissed successfully',
    notFound: 'Notification not found or already dismissed',
    noPermission: 'You don\'t have permission to dismiss this notification'
  },
  kitchen: {
    title: 'Kitchen Management',
    subtitle: 'Manage and track kitchen operations',
    dashboard: 'Dashboard',
    shiftChecklists: 'Shift Checklists',
    wasteTracker: 'Waste Tracker',
    analytics: 'Analytics',
    equipmentStatus: 'Equipment Status',
    foodSafety: 'Food Safety',
    cleaningSchedule: 'Cleaning Schedule',
    backHome: 'Back Home',

    // Kitchen Home
    kitchenDashboard: 'Kitchen Dashboard',
    kitchenOverview: 'Kitchen Overview',
    attentionNeeded: 'Attention Needed',
    taskCompletion: 'Task Completion',
    lastUpdate: 'Last Update',
    pendingChecklists: 'Pending Checklists',
    temperatureChecks: 'Temperature Checks',
    criticalTasks: 'critical tasks need attention',
    todaysWaste: "Today's Waste",
    itemsTracked: 'Items Tracked',
    needsMaintenance: 'Needs Maintenance',
    temperatureAlerts: 'Temperature Alerts',
    equipmentOffline: 'equipment units offline',
    completionRate: 'Completion Rate',
    overdueTasks: 'Overdue Tasks',
    criticalCleaningTasks: 'critical cleaning tasks',

    // Quick Actions
    startFoodSafetyChecklist: 'Start Food Safety Checklist',
    logWasteEntry: 'Log Waste Entry',
    checkEquipmentTemperatures: 'Check Equipment Temperatures',
    completeCleaningTask: 'Complete Cleaning Task',
    completeShiftChecklist: 'Complete Shift Checklist',

    // Waste Tracker
    addWasteEntry: 'Add Waste Entry',
    viewAnalytics: 'View Analytics',
    waste: 'Waste',
    donations: 'Donations',
    todaysDonations: "Today's Donations",
    topDonation: 'Top Donation',
    mostWasted: 'Most Wasted',
    noItemsYet: 'No items yet',
    lastAt: 'Last',
    startTracking: 'Start tracking',
    items: 'Items',
    prices: 'Prices',
    bulkEntry: 'Bulk Entry',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    wasteReason: 'Waste Reason',
    overproduction: 'Overproduction',
    qualityIssues: 'Quality Issues',
    expired: 'Expired',
    droppedContaminated: 'Dropped/Contaminated',
    dropped: 'Dropped',
    todaysEntries: "Today's Entries",
    entries: 'Entries',
    today: 'Today',
    singleDay: 'Single Day',
    dateRange: 'Date Range',
    notes: 'Notes',
    noDonationsLoggedToday: 'No donations logged today',
    noDonationsLogged: 'No donations logged',
    noWasteLoggedToday: 'No waste logged today',
    noWasteLogged: 'No waste logged',
    tapItemsAbove: 'Tap items above to start tracking',
    itemsLogged: 'items logged',
    processing: 'Processing...',
    added: 'Added!',
    customItems: 'Custom Items',
    customItemsDescription: 'Add, edit, or remove custom waste items.',
    managePrices: 'Manage Prices',
    managePricesDescription: 'Customize item prices for your store.',
    printReport: 'Print Report',
    generatedBy: 'Generated by CFA Kitchen Management System',
    lbs: 'lbs',
    oz: 'oz',
    customEntry: 'Custom Entry',
    itemName: 'Item name',
    weightLbs: 'Weight (lbs)',
    qty: 'Qty',
    price: 'Price ($)',
    addEntry: 'Add Entry',
    deleteEntry: 'Delete Entry?',
    deleteEntryDescription: 'This action cannot be undone.',
    addDonation: 'Add Donation',
    enterDetailsFor: 'Enter details for',
    beingDonated: 'being donated',
    byWeight: 'By Weight',
    byQuantity: 'By Quantity',
    weight: 'Weight',
    enterWeight: 'Enter weight',
    quantityItems: 'Quantity (items)',
    enterNumberOfItems: 'Enter number of items',

    // Equipment
    addEquipment: 'Add Equipment',
    reportIssue: 'Report Issue',

    // Food Safety
    completeChecklist: 'Complete Checklist',
    addChecklist: 'Add Checklist',

    // Cleaning
    markComplete: 'Mark Complete',
    addTask: 'Add Task',
  },
  roadmaps: {
    // Metrics
    metrics: 'Metrics',
    metric: 'Metric',
    currentValue: 'Current Value',
    target: 'Target',
    performance: 'Performance',
    trend: 'Trend',
    history: 'History',
    lastUpdated: 'Last Updated',
    updateMetric: 'Update Metric',
    addMetric: 'Add Metric',

    // Chart and Trend
    preview: 'Preview',
    startTracking: 'Start Tracking',
    noChange: 'No Change',
    points: 'points',
    actual: 'Actual',
    noData: 'No Data'
  }
};